import React, { useState, useEffect } from 'react';
import '../App.css';
import { getCurrentUser, fetchUserAttributes } from 'aws-amplify/auth';
import { marked } from 'marked';
import DOMPurify from 'dompurify';

const Consequences = () => {
    const [socialIssue, setSocialIssue] = useState('');
    const [answer, setAnswer] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [geography, setGeography] = useState(''); 
    const [sessionId, setSessionId] = useState(null);
    const [user, setUser] = useState(null);
    const [feedbackGiven, setFeedbackGiven] = useState(false); // New state for feedback

    const handleInputChange = (e) => {
        setSocialIssue(e.target.value);
    };

    const handleFeedback = async (feedbackType, interactionId) => {
        try {
            const response = await fetch('https://jnhyo3iqg4.execute-api.eu-north-1.amazonaws.com/feedback', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ 
                "interaction_id": interactionId, 
                "feedback": feedbackType 
            }), // Send interaction ID and feedback text
          });
          console.log('Feedback submitted:', response);
          setFeedbackGiven(true); 
        } catch (error) {
          console.error('Error submitting feedback:', error);
        }
      };
    
    // create a session id for the conversation
    useEffect(() => {
        const sessionId = Math.random().toString(36).substring(7);
        setSessionId(sessionId);
    }, []);
    
    useEffect(() => {
      fetchUser();
    }, []);

    async function fetchUser() {
        try {
          const currentUser = await getCurrentUser();
          const userAttributes = await fetchUserAttributes();
          setUser({ ...currentUser, ...userAttributes });
        } catch (error) {
          console.error('Error fetching user', error);
        }
    }

    const callAPI = async (e) => {
        e.preventDefault();
        setLoading(true);
        setAnswer(null);
        setError(null);
        setFeedbackGiven(false);

        try {
            const response = await fetch("https://jnhyo3iqg4.execute-api.eu-north-1.amazonaws.com/question", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    "question": "What are the consequences of this social issue?",
                    "social_issue": socialIssue,
                    "geography": geography,
                    "user_id": user.username,
                    "session_id": sessionId
                }),
            });

            if (!response.ok) {
                throw new Error(`Error: ${response.statusText}`);
              }
              const data = await response.json();
              if (data.answer) {
                console.log('Answer:', data.answer);
                  setAnswer({
                      answer: data.answer,
                      source_map: data.links, // || {}
                      interaction_id: data.interactionId
                  });
              } else {
                  setAnswer('Answer field is missing in the response.');
              }
              } catch (error) {
                  setAnswer(error.message);
                  console.error('Fetch error:', error);
              } finally {
                  setLoading(false);
              }
          };
        
         
    function formatTextWithLinksAndNewLines(text, sourceMap) {
   
        // Split the text by references like [1], [2] without separating from punctuation
        const parts = text.split(/(\[\d+\][.,;!?]?)/); // Match references with optional punctuation after them
    
        return parts.map((part, index) => {
            // Match patterns like [1], [2] including any following punctuation mark
            const match = part.match(/\[(\d+)\](.?)?/);
    
            if (match) {
                const sourceIndex = match[1];
                const punctuation = match[2] || ''; // Capture punctuation if any
    
                return (
                    <React.Fragment key={`link-${index}`}>
                        <a
                            href={sourceMap[sourceIndex]}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ textDecoration: 'none', display: 'inline' }} // Ensure inline display
                        >
                            [{sourceIndex}]
                        </a>
                        {punctuation} {/* Add the punctuation immediately after the link */}
                    </React.Fragment>
                );
            }
    
            // Check if the part contains a newline character (from potato replacement)
            if (part.includes('\n')) {
                return part.split('\n').map((line, idx) => (
                    <React.Fragment key={`line-${index}-${idx}`}>
                        {line}
                        {idx < part.split('\n').length - 1 && <br />} {/* Add <br> for each line break */}
                    </React.Fragment>
                ));
            }
    
            // Return the plain text part as is
            return part;
        });
    }

            function copyToClipboard() {
                const answerDiv = document.getElementById('answerDiv');
                const text = answerDiv.innerText; // Extract only the text content
                const textArea = document.createElement('textarea');
                textArea.value = text;
                document.body.appendChild(textArea);
                textArea.select();
                document.execCommand('copy');
                document.body.removeChild(textArea);
                
            }
       

    return (
        <div>
            <div className="title-section">
                <h2 className="title-text">Consequences Tracking Assistant</h2>
                <img src="https://rfc-info.s3.eu-north-1.amazonaws.com/Consequence_Tracking.png" alt="RFC Problem Analysis" className="title-icon2" />
            </div>
                <form onSubmit={callAPI}>
                    <div className="input-container">
                        <h4 htmlFor="Question">What are the consequences of this social issue?</h4>
                        <input type="hidden" id="Question" value="What are the consequences of this social issue?" />
                    </div>
                    <div className="input-grid">
                        <div className="input-container">
                            <label>Enter the social issue:</label>
                            <input
                                type="text"
                                id="socialIssue"
                                placeholder="Enter social issue..."
                                required
                                value={socialIssue}
                                onChange={(e) => setSocialIssue(e.target.value)}
                            />
                            </div>
                            <div className="input-container">
                            <label htmlFor="geography">Enter the geography:</label>
                            <input
                                type="text"
                                id="geography"
                                placeholder="Enter geography..."
                                required
                                value={geography}
                                onChange={(e) => setGeography(e.target.value)}
                            />
                        </div>
                    </div>
                    <p className="placeholder-text-ai">Note: AI-generated content may contain errors. Please verify information in links provided.</p>
                    <button type="submit">Search for Consequences</button>
                </form>
                {loading && (
                    <div id="loader" className="loader">
                        <span className="loader-text">Loading...</span>
                        <span className="load"></span>
                    </div>
                )}
                <div id="answerDiv" aria-live="polite">
                {answer && typeof answer === 'object' ? (
                    <div>
                        <p><strong>Answer:</strong></p>
                        <div>{formatTextWithLinksAndNewLines(answer.answer, answer.source_map)}</div>
                        <div>
                            <h4>Source Map:</h4>
                            <ul>
                                {Object.entries(answer.source_map).map(([index, url]) => (
                                    <li key={index}>
                                        <a href={url} target="_blank" rel="noopener noreferrer">
                                            [{index}]: {url}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <br/>
                        <p className="placeholder-text-ai">Note: AI-generated content may contain errors. Please verify information in links provided.</p>
                        <div onClick={copyToClipboard} class="Btn" role="button" tabindex="0" onclick="copyToClipboard()">
                        <span class="text">Copy</span>
                        <span class="svgIcon">
                            <svg fill="white" viewBox="0 0 384 512" height="1em" xmlns="http://www.w3.org/2000/svg">
                            <path d="M280 64h40c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128C0 92.7 28.7 64 64 64h40 9.6C121 27.5 153.3 0 192 0s71 27.5 78.4 64H280zM64 112c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H320c8.8 0 16-7.2 16-16V128c0-8.8-7.2-16-16-16H304v24c0 13.3-10.7 24-24 24H192 104c-13.3 0-24-10.7-24-24V112H64zm128-8a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"></path>
                            </svg>
                        </span>
                        </div>
                    {!feedbackGiven ? (
                        <div className="input-row">
                            <div className="checkboxButton" onClick={() => handleFeedback('Like', answer.interaction_id)}>
                                <label className="feedback">
                                    <input type="checkbox" />
                                    <svg
                                        id="Glyph"
                                        version="1.1"
                                        viewBox="0 0 32 32"
                                        xmlSpace="preserve"
                                        xmlns="http://www.w3.org/2000/svg"
                                        xmlnsXlink="http://www.w3.org/1999/xlink"
                                    >
                                        <path
                                            d="M29.845,17.099l-2.489,8.725C26.989,27.105,25.804,28,24.473,28H11c-0.553,0-1-0.448-1-1V13  c0-0.215,0.069-0.425,0.198-0.597l5.392-7.24C16.188,4.414,17.05,4,17.974,4C19.643,4,21,5.357,21,7.026V12h5.002  c1.265,0,2.427,0.579,3.188,1.589C29.954,14.601,30.192,15.88,29.845,17.099z"
                                            id="XMLID_254_"
                                        ></path>
                                        <path
                                            d="M7,12H3c-0.553,0-1,0.448-1,1v14c0,0.552,0.447,1,1,1h4c0.553,0,1-0.448,1-1V13C8,12.448,7.553,12,7,12z   M5,25.5c-0.828,0-1.5-0.672-1.5-1.5c0-0.828,0.672-1.5,1.5-1.5c0.828,0,1.5,0.672,1.5,1.5C6.5,24.828,5.828,25.5,5,25.5z"
                                            id="XMLID_256_"
                                        ></path>
                                    </svg>
                                </label>
                            </div>
                            <div className="checkboxButton" onClick={() => handleFeedback('Dislike', answer.interaction_id)}>
                                <label className="feedback">
                                    <input type="checkbox" />
                                    <svg
                                        id="Glyph"
                                        version="1.1"
                                        viewBox="0 0 32 32"
                                        xmlSpace="preserve"
                                        xmlns="http://www.w3.org/2000/svg"
                                        xmlnsXlink="http://www.w3.org/1999/xlink"
                                    >
                                        <path d="M2.156,14.901l2.489-8.725C5.012,4.895,6.197,4,7.528,4h13.473C21.554,4,22,4.448,22,5v14  c0,0.215-0.068,0.425-0.197,0.597l-5.392,7.24C15.813,27.586,14.951,28,14.027,28c-1.669,0-3.026-1.357-3.026-3.026V20H5.999  c-1.265,0-2.427-0.579-3.188-1.589C2.047,17.399,1.809,16.12,2.156,14.901z"
                                            id="XMLID_259_"></path>
                                        <path d="M25.001,20h4C29.554,20,30,19.552,30,19V5c0-0.552-0.446-1-0.999-1h-4c-0.553,0-1,0.448-1,1v14  C24.001,19.552,24.448,20,25.001,20z M27.001,6.5c0.828,0,1.5,0.672,1.5,1.5c0,0.828-0.672,1.5-1.5,1.5c-0.828,0-1.5-0.672-1.5  C25.501,7.172,26.173,6.5,27.001,6.5z"
                                            id="XMLID_260_"></path>
                                    </svg>
                                </label>
                            </div>
                        </div>
                    ) : (
                        <p className="feedback-thanks">Thank you for your feedback! 😄</p>
                    )}
                </div>
            ) : (
        <p className="error">{answer}</p>
            )}
        </div>
            </div>
        );
    };

export default Consequences;